// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Las últimas cargas del dashboard (20-oct-2026; rediseño de esa misma tarde). Ver RecentLoadsCard.tsx.
 *
 * 📌 \`--status\`, \`--progress\` y \`--delay\` los pone cada renglón en línea. No son tokens del tema (no empiezan con
 * \`--dylo-\`), así que \`styles/tokens.test.ts\` no los busca.
 */

/* Un brillo naranja apenas, desde la esquina: la misma familia que la cabecera de What's new. */
.RecentLoadsCard_card__zxZTA {
  position: relative;
  overflow: hidden;
  container: recent / inline-size;
}
.RecentLoadsCard_card__zxZTA::before {
  content: '';
  position: absolute;
  inset: 0;
  background: radial-gradient(
    120% 90% at 100% 0%,
    color-mix(in srgb, var(--dylo-orange) 9%, transparent) 0%,
    transparent 55%
  );
  pointer-events: none;
}
.RecentLoadsCard_card__zxZTA > * {
  position: relative;
}

.RecentLoadsCard_heading__tlyGr {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.RecentLoadsCard_sub__mOX9S {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin: 0;
  font-size: 12.5px;
  color: var(--dylo-muted);
}

.RecentLoadsCard_chip__ia6gr {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 9px;
  border-radius: 999px;
  font-size: 11.5px;
  font-weight: 600;
  color: var(--dylo-ink);
  background: color-mix(in srgb, #2f9fd0 16%, transparent);
}
.RecentLoadsCard_chip__ia6gr::before {
  content: '';
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #2f9fd0;
  box-shadow: 0 0 0 3px color-mix(in srgb, #2f9fd0 25%, transparent);
}

.RecentLoadsCard_viewAll__irLDM {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 6px 10px 6px 14px;
  border-radius: 999px;
  font-size: 12.5px;
  font-weight: 600;
  color: var(--dylo-orange);
  text-decoration: none;
  border: 1px solid color-mix(in srgb, var(--dylo-orange) 35%, transparent);
  transition: background-color 0.15s ease, border-color 0.15s ease;
}
.RecentLoadsCard_viewAll__irLDM:hover,
.RecentLoadsCard_viewAll__irLDM:focus-visible {
  background: color-mix(in srgb, var(--dylo-orange) 12%, transparent);
  border-color: color-mix(in srgb, var(--dylo-orange) 60%, transparent);
}

.RecentLoadsCard_list__7D7Zh {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.RecentLoadsCard_item__tdZJQ {
  animation: RecentLoadsCard_rl-rise__oT3cL 0.4s ease both;
  animation-delay: var(--delay);
}

/* Renglón entero clicable: referencia | tramo | estatus y fecha | flecha. */
.RecentLoadsCard_row__90pPq {
  position: relative;
  display: grid;
  grid-template-columns: minmax(110px, 0.8fr) minmax(200px, 1.7fr) minmax(112px, auto) 16px;
  align-items: center;
  gap: 18px;
  padding: 11px 12px 11px 16px;
  border-radius: 12px;
  color: inherit;
  text-decoration: none;
  transition: background-color 0.18s ease;
}
/* La barra del estatus, a la izquierda: se reconoce el estado de la lista sin leerla. */
.RecentLoadsCard_row__90pPq::before {
  content: '';
  position: absolute;
  left: 4px;
  top: 10px;
  bottom: 10px;
  width: 3px;
  border-radius: 3px;
  background: var(--status);
}
.RecentLoadsCard_row__90pPq:hover,
.RecentLoadsCard_row__90pPq:focus-visible {
  background: color-mix(in srgb, var(--status) 9%, transparent);
}
.RecentLoadsCard_row__90pPq:focus-visible {
  outline: 2px solid color-mix(in srgb, var(--status) 70%, transparent);
  outline-offset: 1px;
}

.RecentLoadsCard_ident__HqK1B {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.RecentLoadsCard_ref__s7EcN {
  font-size: 13.5px;
  font-weight: 700;
  letter-spacing: 0.01em;
  color: var(--dylo-ink);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.RecentLoadsCard_meta__wt-2m {
  font-size: 12px;
  color: var(--dylo-muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ============================ El tramo ============================ */

.RecentLoadsCard_route__svsPj {
  min-width: 0;
  display: grid;
  grid-template-columns: minmax(0, auto) minmax(56px, 1fr) minmax(0, auto);
  align-items: center;
  gap: 12px;
}

.RecentLoadsCard_place__8cBIo {
  max-width: 130px;
  font-size: 12.5px;
  font-weight: 500;
  color: var(--dylo-ink);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Lo que falta, punteado; lo recorrido, del color del estatus. */
.RecentLoadsCard_track__qI4mT {
  position: relative;
  height: 2px;
  border-radius: 2px;
  background: repeating-linear-gradient(
    90deg,
    color-mix(in srgb, var(--dylo-ink) 26%, transparent) 0 5px,
    transparent 5px 10px
  );
}
/* Origen (ya salió de ahí o está por salir) y destino. */
.RecentLoadsCard_track__qI4mT::before,
.RecentLoadsCard_track__qI4mT::after {
  content: '';
  position: absolute;
  top: 50%;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  transform: translateY(-50%);
  box-sizing: border-box;
}
.RecentLoadsCard_track__qI4mT::before {
  left: -4px;
  background: var(--status);
}
.RecentLoadsCard_track__qI4mT::after {
  right: -4px;
  background: var(--dylo-surface);
  border: 2px solid color-mix(in srgb, var(--dylo-ink) 35%, transparent);
}
.RecentLoadsCard_arrived__p-MID .RecentLoadsCard_track__qI4mT::after {
  background: var(--status);
  border-color: var(--status);
}

.RecentLoadsCard_fill__oGKI4 {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: var(--progress);
  border-radius: inherit;
  background: var(--status);
  animation: RecentLoadsCard_rl-fill__JFMBY 0.9s cubic-bezier(0.2, 0.7, 0.2, 1) both;
  animation-delay: calc(var(--delay) + 120ms);
}

.RecentLoadsCard_truck__SNzn9 {
  position: absolute;
  top: 50%;
  left: var(--progress);
  width: 24px;
  height: 24px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  transform: translate(-50%, -50%);
  color: var(--status);
  background: var(--dylo-surface);
  box-shadow: 0 0 0 2px color-mix(in srgb, var(--status) 55%, transparent),
    0 0 14px color-mix(in srgb, var(--status) 35%, transparent);
  animation: RecentLoadsCard_rl-drive__IjhNe 0.9s cubic-bezier(0.2, 0.7, 0.2, 1) both;
  animation-delay: calc(var(--delay) + 120ms);
}

/* Fuera del ciclo (Dry run, o un estatus desconocido): el tramo entero en su color, punteado y sin camión. */
.RecentLoadsCard_stopped__GMyd9 .RecentLoadsCard_track__qI4mT {
  background: repeating-linear-gradient(
    90deg,
    color-mix(in srgb, var(--status) 65%, transparent) 0 5px,
    transparent 5px 10px
  );
}
.RecentLoadsCard_stopped__GMyd9 .RecentLoadsCard_fill__oGKI4 {
  display: none;
}

/* ======================== Estatus y fecha ========================= */

.RecentLoadsCard_state__M7vGd {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 5px;
}

/*
 * Punto y fondo con el color, letra con la tinta normal: el naranja de "Assigned" como letra no se lee sobre fondo
 * claro; como punto sí.
 */
.RecentLoadsCard_pill__y3ZWk {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  color: var(--dylo-ink);
  background: color-mix(in srgb, var(--status) 16%, transparent);
}
.RecentLoadsCard_pill__y3ZWk::before {
  content: '';
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--status);
}

.RecentLoadsCard_date__TFf9h {
  font-size: 11.5px;
  color: var(--dylo-muted);
  white-space: nowrap;
}

.RecentLoadsCard_chevron__Yi7Bd {
  color: var(--dylo-muted);
  opacity: 0;
  transform: translateX(-4px);
  transition: opacity 0.18s ease, transform 0.18s ease;
}
.RecentLoadsCard_row__90pPq:hover .RecentLoadsCard_chevron__Yi7Bd,
.RecentLoadsCard_row__90pPq:focus-visible .RecentLoadsCard_chevron__Yi7Bd {
  opacity: 1;
  transform: translateX(0);
}

/* ========================== Sin cargas ============================ */

.RecentLoadsCard_empty__f0QvD {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 28px 12px 20px;
  text-align: center;
}
.RecentLoadsCard_emptyIcon__cF\\+7B {
  width: 46px;
  height: 46px;
  display: grid;
  place-items: center;
  border-radius: 14px;
  color: var(--dylo-orange);
  background: color-mix(in srgb, var(--dylo-orange) 14%, transparent);
  margin-bottom: 4px;
}
.RecentLoadsCard_emptyTitle__6r4VX {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: var(--dylo-ink);
}
.RecentLoadsCard_emptyText__J6AOM {
  margin: 0;
  font-size: 12.5px;
  color: var(--dylo-muted);
}

/* ===================== Según el ancho de la tarjeta =================== */

/* Angosta: el tramo baja a su propio renglón, a todo el ancho. */
@container recent (max-width: 640px) {
  .RecentLoadsCard_row__90pPq {
    grid-template-columns: minmax(0, 1fr) auto 16px;
    row-gap: 10px;
  }
  .RecentLoadsCard_route__svsPj {
    grid-column: 1 / -1;
    grid-row: 2;
  }
}
@container recent (max-width: 420px) {
  .RecentLoadsCard_row__90pPq {
    grid-template-columns: minmax(0, 1fr) auto;
  }
  .RecentLoadsCard_chevron__Yi7Bd {
    display: none;
  }
}

/* ============================ Movimiento ========================== */

@keyframes RecentLoadsCard_rl-rise__oT3cL {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
}
@keyframes RecentLoadsCard_rl-fill__JFMBY {
  from {
    width: 0;
  }
}
@keyframes RecentLoadsCard_rl-drive__IjhNe {
  from {
    left: 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  .RecentLoadsCard_item__tdZJQ,
  .RecentLoadsCard_fill__oGKI4,
  .RecentLoadsCard_truck__SNzn9 {
    animation: none;
  }
  .RecentLoadsCard_row__90pPq,
  .RecentLoadsCard_chevron__Yi7Bd,
  .RecentLoadsCard_viewAll__irLDM {
    transition: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/v2/pages/Dashboard/components/RecentLoadsCard.module.css"],"names":[],"mappings":"AAAA;;;;;EAKE;;AAEF,gGAAgG;AAChG;EACE,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;AACjC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR;;;;GAIC;EACD,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,SAAS;EACT,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,wDAAwD;AAC1D;AACA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,kEAAkE;AACpE;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;EAC1B,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,yEAAyE;EACzE,gEAAgE;AAClE;AACA;;EAEE,mEAAmE;EACnE,qEAAqE;AACvE;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,wDAAiC;EACjC,6BAA6B;AAC/B;;AAEA,4EAA4E;AAC5E;EACE,kBAAkB;EAClB,aAAa;EACb,yFAAyF;EACzF,mBAAmB;EACnB,SAAS;EACT,4BAA4B;EAC5B,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,uCAAuC;AACzC;AACA,wFAAwF;AACxF;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;;EAEE,6DAA6D;AAC/D;AACA;EACE,qEAAqE;EACrE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,uEAAuE;;AAEvE;EACE,YAAY;EACZ,aAAa;EACb,wEAAwE;EACxE,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,iEAAiE;AACjE;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB;;;;GAIC;AACH;AACA,yDAAyD;AACzD;;EAEE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,2BAA2B;EAC3B,sBAAsB;AACxB;AACA;EACE,UAAU;EACV,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,+BAA+B;EAC/B,sEAAsE;AACxE;AACA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;EACzB,kFAA2D;EAC3D,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,oBAAoB;EACpB,+BAA+B;EAC/B;+DAC6D;EAC7D,mFAA4D;EAC5D,2CAA2C;AAC7C;;AAEA,6GAA6G;AAC7G;EACE;;;;GAIC;AACH;AACA;EACE,aAAa;AACf;;AAEA,uEAAuE;;AAEvE;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;AACV;;AAEA;;;EAGE;AACF;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,8DAA8D;AAChE;AACA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,UAAU;EACV,2BAA2B;EAC3B,oDAAoD;AACtD;AACA;;EAEE,UAAU;EACV,wBAAwB;AAC1B;;AAEA,uEAAuE;;AAEvE;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,mEAAmE;EACnE,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,SAAS;EACT,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA,2EAA2E;;AAE3E,iEAAiE;AACjE;EACE;IACE,+CAA+C;IAC/C,aAAa;EACf;EACA;IACE,mBAAmB;IACnB,WAAW;EACb;AACF;AACA;EACE;IACE,0CAA0C;EAC5C;EACA;IACE,aAAa;EACf;AACF;;AAEA,uEAAuE;;AAEvE;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,QAAQ;EACV;AACF;AACA;EACE;IACE,OAAO;EACT;AACF;;AAEA;EACE;;;IAGE,eAAe;EACjB;EACA;;;IAGE,gBAAgB;EAClB;AACF","sourcesContent":["/*\n * Las últimas cargas del dashboard (20-oct-2026; rediseño de esa misma tarde). Ver RecentLoadsCard.tsx.\n *\n * 📌 `--status`, `--progress` y `--delay` los pone cada renglón en línea. No son tokens del tema (no empiezan con\n * `--dylo-`), así que `styles/tokens.test.ts` no los busca.\n */\n\n/* Un brillo naranja apenas, desde la esquina: la misma familia que la cabecera de What's new. */\n.card {\n  position: relative;\n  overflow: hidden;\n  container: recent / inline-size;\n}\n.card::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: radial-gradient(\n    120% 90% at 100% 0%,\n    color-mix(in srgb, var(--dylo-orange) 9%, transparent) 0%,\n    transparent 55%\n  );\n  pointer-events: none;\n}\n.card > * {\n  position: relative;\n}\n\n.heading {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n}\n\n.sub {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin: 0;\n  font-size: 12.5px;\n  color: var(--dylo-muted);\n}\n\n.chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 2px 9px;\n  border-radius: 999px;\n  font-size: 11.5px;\n  font-weight: 600;\n  color: var(--dylo-ink);\n  background: color-mix(in srgb, #2f9fd0 16%, transparent);\n}\n.chip::before {\n  content: '';\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: #2f9fd0;\n  box-shadow: 0 0 0 3px color-mix(in srgb, #2f9fd0 25%, transparent);\n}\n\n.viewAll {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n  padding: 6px 10px 6px 14px;\n  border-radius: 999px;\n  font-size: 12.5px;\n  font-weight: 600;\n  color: var(--dylo-orange);\n  text-decoration: none;\n  border: 1px solid color-mix(in srgb, var(--dylo-orange) 35%, transparent);\n  transition: background-color 0.15s ease, border-color 0.15s ease;\n}\n.viewAll:hover,\n.viewAll:focus-visible {\n  background: color-mix(in srgb, var(--dylo-orange) 12%, transparent);\n  border-color: color-mix(in srgb, var(--dylo-orange) 60%, transparent);\n}\n\n.list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.item {\n  animation: rl-rise 0.4s ease both;\n  animation-delay: var(--delay);\n}\n\n/* Renglón entero clicable: referencia | tramo | estatus y fecha | flecha. */\n.row {\n  position: relative;\n  display: grid;\n  grid-template-columns: minmax(110px, 0.8fr) minmax(200px, 1.7fr) minmax(112px, auto) 16px;\n  align-items: center;\n  gap: 18px;\n  padding: 11px 12px 11px 16px;\n  border-radius: 12px;\n  color: inherit;\n  text-decoration: none;\n  transition: background-color 0.18s ease;\n}\n/* La barra del estatus, a la izquierda: se reconoce el estado de la lista sin leerla. */\n.row::before {\n  content: '';\n  position: absolute;\n  left: 4px;\n  top: 10px;\n  bottom: 10px;\n  width: 3px;\n  border-radius: 3px;\n  background: var(--status);\n}\n.row:hover,\n.row:focus-visible {\n  background: color-mix(in srgb, var(--status) 9%, transparent);\n}\n.row:focus-visible {\n  outline: 2px solid color-mix(in srgb, var(--status) 70%, transparent);\n  outline-offset: 1px;\n}\n\n.ident {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.ref {\n  font-size: 13.5px;\n  font-weight: 700;\n  letter-spacing: 0.01em;\n  color: var(--dylo-ink);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.meta {\n  font-size: 12px;\n  color: var(--dylo-muted);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* ============================ El tramo ============================ */\n\n.route {\n  min-width: 0;\n  display: grid;\n  grid-template-columns: minmax(0, auto) minmax(56px, 1fr) minmax(0, auto);\n  align-items: center;\n  gap: 12px;\n}\n\n.place {\n  max-width: 130px;\n  font-size: 12.5px;\n  font-weight: 500;\n  color: var(--dylo-ink);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Lo que falta, punteado; lo recorrido, del color del estatus. */\n.track {\n  position: relative;\n  height: 2px;\n  border-radius: 2px;\n  background: repeating-linear-gradient(\n    90deg,\n    color-mix(in srgb, var(--dylo-ink) 26%, transparent) 0 5px,\n    transparent 5px 10px\n  );\n}\n/* Origen (ya salió de ahí o está por salir) y destino. */\n.track::before,\n.track::after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  transform: translateY(-50%);\n  box-sizing: border-box;\n}\n.track::before {\n  left: -4px;\n  background: var(--status);\n}\n.track::after {\n  right: -4px;\n  background: var(--dylo-surface);\n  border: 2px solid color-mix(in srgb, var(--dylo-ink) 35%, transparent);\n}\n.arrived .track::after {\n  background: var(--status);\n  border-color: var(--status);\n}\n\n.fill {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  width: var(--progress);\n  border-radius: inherit;\n  background: var(--status);\n  animation: rl-fill 0.9s cubic-bezier(0.2, 0.7, 0.2, 1) both;\n  animation-delay: calc(var(--delay) + 120ms);\n}\n\n.truck {\n  position: absolute;\n  top: 50%;\n  left: var(--progress);\n  width: 24px;\n  height: 24px;\n  display: grid;\n  place-items: center;\n  border-radius: 50%;\n  transform: translate(-50%, -50%);\n  color: var(--status);\n  background: var(--dylo-surface);\n  box-shadow: 0 0 0 2px color-mix(in srgb, var(--status) 55%, transparent),\n    0 0 14px color-mix(in srgb, var(--status) 35%, transparent);\n  animation: rl-drive 0.9s cubic-bezier(0.2, 0.7, 0.2, 1) both;\n  animation-delay: calc(var(--delay) + 120ms);\n}\n\n/* Fuera del ciclo (Dry run, o un estatus desconocido): el tramo entero en su color, punteado y sin camión. */\n.stopped .track {\n  background: repeating-linear-gradient(\n    90deg,\n    color-mix(in srgb, var(--status) 65%, transparent) 0 5px,\n    transparent 5px 10px\n  );\n}\n.stopped .fill {\n  display: none;\n}\n\n/* ======================== Estatus y fecha ========================= */\n\n.state {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 5px;\n}\n\n/*\n * Punto y fondo con el color, letra con la tinta normal: el naranja de \"Assigned\" como letra no se lee sobre fondo\n * claro; como punto sí.\n */\n.pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 3px 10px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n  color: var(--dylo-ink);\n  background: color-mix(in srgb, var(--status) 16%, transparent);\n}\n.pill::before {\n  content: '';\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: var(--status);\n}\n\n.date {\n  font-size: 11.5px;\n  color: var(--dylo-muted);\n  white-space: nowrap;\n}\n\n.chevron {\n  color: var(--dylo-muted);\n  opacity: 0;\n  transform: translateX(-4px);\n  transition: opacity 0.18s ease, transform 0.18s ease;\n}\n.row:hover .chevron,\n.row:focus-visible .chevron {\n  opacity: 1;\n  transform: translateX(0);\n}\n\n/* ========================== Sin cargas ============================ */\n\n.empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  padding: 28px 12px 20px;\n  text-align: center;\n}\n.emptyIcon {\n  width: 46px;\n  height: 46px;\n  display: grid;\n  place-items: center;\n  border-radius: 14px;\n  color: var(--dylo-orange);\n  background: color-mix(in srgb, var(--dylo-orange) 14%, transparent);\n  margin-bottom: 4px;\n}\n.emptyTitle {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--dylo-ink);\n}\n.emptyText {\n  margin: 0;\n  font-size: 12.5px;\n  color: var(--dylo-muted);\n}\n\n/* ===================== Según el ancho de la tarjeta =================== */\n\n/* Angosta: el tramo baja a su propio renglón, a todo el ancho. */\n@container recent (max-width: 640px) {\n  .row {\n    grid-template-columns: minmax(0, 1fr) auto 16px;\n    row-gap: 10px;\n  }\n  .route {\n    grid-column: 1 / -1;\n    grid-row: 2;\n  }\n}\n@container recent (max-width: 420px) {\n  .row {\n    grid-template-columns: minmax(0, 1fr) auto;\n  }\n  .chevron {\n    display: none;\n  }\n}\n\n/* ============================ Movimiento ========================== */\n\n@keyframes rl-rise {\n  from {\n    opacity: 0;\n    transform: translateY(6px);\n  }\n}\n@keyframes rl-fill {\n  from {\n    width: 0;\n  }\n}\n@keyframes rl-drive {\n  from {\n    left: 0;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .item,\n  .fill,\n  .truck {\n    animation: none;\n  }\n  .row,\n  .chevron,\n  .viewAll {\n    transition: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `RecentLoadsCard_card__zxZTA`,
	"heading": `RecentLoadsCard_heading__tlyGr`,
	"sub": `RecentLoadsCard_sub__mOX9S`,
	"chip": `RecentLoadsCard_chip__ia6gr`,
	"viewAll": `RecentLoadsCard_viewAll__irLDM`,
	"list": `RecentLoadsCard_list__7D7Zh`,
	"item": `RecentLoadsCard_item__tdZJQ`,
	"rl-rise": `RecentLoadsCard_rl-rise__oT3cL`,
	"row": `RecentLoadsCard_row__90pPq`,
	"ident": `RecentLoadsCard_ident__HqK1B`,
	"ref": `RecentLoadsCard_ref__s7EcN`,
	"meta": `RecentLoadsCard_meta__wt-2m`,
	"route": `RecentLoadsCard_route__svsPj`,
	"place": `RecentLoadsCard_place__8cBIo`,
	"track": `RecentLoadsCard_track__qI4mT`,
	"arrived": `RecentLoadsCard_arrived__p-MID`,
	"fill": `RecentLoadsCard_fill__oGKI4`,
	"rl-fill": `RecentLoadsCard_rl-fill__JFMBY`,
	"truck": `RecentLoadsCard_truck__SNzn9`,
	"rl-drive": `RecentLoadsCard_rl-drive__IjhNe`,
	"stopped": `RecentLoadsCard_stopped__GMyd9`,
	"state": `RecentLoadsCard_state__M7vGd`,
	"pill": `RecentLoadsCard_pill__y3ZWk`,
	"date": `RecentLoadsCard_date__TFf9h`,
	"chevron": `RecentLoadsCard_chevron__Yi7Bd`,
	"empty": `RecentLoadsCard_empty__f0QvD`,
	"emptyIcon": `RecentLoadsCard_emptyIcon__cF+7B`,
	"emptyTitle": `RecentLoadsCard_emptyTitle__6r4VX`,
	"emptyText": `RecentLoadsCard_emptyText__J6AOM`
};
export default ___CSS_LOADER_EXPORT___;
